<div class="content d-flex justify-content-center align-items-center flex-column background-grey">
    <mat-card appearance="outlined" class="col-11 col-lg-8 col-md-9 col-xl-6 p-5 d-flex flex-column">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
            <div class="d-flex flex-column justify-content-center">
                <div class="mat-headline-5 foreground-primary-darker fw-bold">MAWB:</div>
                <div class="mat-headline-3 mb-0 pb-0 fw-light foreground-primary-darker">
                    {{ mawb }}
                </div>
            </div>
            <app-image-by-facility class="mt-3" src="plane" alt="Plane" height="150" width="245" />
        </div>
        <mat-divider class="w-100 my-3" />
        <div class="d-flex flex-column">
            <div class="mt-1 mb-0 mat-subtitle-1">Your payment must match your clearance.</div>
            <div class="mat-subtitle-1">If you are not sure, contact your station before a payment is made.</div>
            <mat-divider class="w-100 mb-3" />
            <div class="d-flex flex-column flex-md-row col-12 mt-3">
                <div class="d-flex flex-column col-12 col-md-6 pe-md-2 pb-4 pb-md-0">
                    <div class="d-flex flex-row flex-grow-1">
                        <app-image-by-facility src="package" alt="MAWB" height="20" width="17" class="mt-1" />
                        <div class="d-flex ms-2 flex-column">
                            <div class="mat-headline-5 foreground-primary-darker m-0">
                                {{ paymentConfiguration.mawb?.title }}
                            </div>
                            <div class="mat-subtitle-2 foreground-disabled-text fw-light">
                                {{ paymentConfiguration.mawb?.subtitle }} &nbsp;
                            </div>
                        </div>
                    </div>
                    <form [formGroup]="firmsCodeForm">
                        <mat-form-field class="col-12 mt-3">
                            <mat-label>Enter Firms Code</mat-label>
                            <input
                                matInput
                                type="firmsCode"
                                formControlName="firmsCode"
                                placeholder="Enter Firms Code"
                                maxlength="4"
                            />
                            <mat-error>
                                <app-field-error [messageList]="formErrors['firmsCode']" [field]="'firmsCode'" />
                            </mat-error>
                        </mat-form-field>
                    </form>
                    <button
                        matButton="filled"
                        type="button"
                        class="mt-2 align-self-center"
                        (click)="selectPaymentType(PaymentCartTypeType.MAWB)"
                        color="primary"
                        [disabled]="!firmsCodeForm.valid"
                    >
                        PAY
                    </button>
                </div>
                <div class="d-flex flex-column col-12 col-md-6 ps-md-2">
                    <div class="d-flex flex-row align-items-start flex-grow-1">
                        <app-image-by-facility src="packages" alt="HAWB" height="20" width="22" class="mt-1" />
                        <div class="d-flex ms-2 flex-column">
                            <div class="mat-headline-5 foreground-primary-darker m-0">
                                {{ paymentConfiguration.hawb?.title }}
                            </div>
                            <div class="mat-subtitle-2 foreground-disabled-text fw-light">
                                {{ paymentConfiguration.hawb?.subtitle }}&nbsp;
                            </div>
                        </div>
                    </div>
                    <button
                        matButton="filled"
                        type="button"
                        class="mt-2 align-self-center"
                        (click)="selectPaymentType(PaymentCartTypeType.HAWB)"
                        color="primary"
                    >
                        PAY
                    </button>
                </div>
            </div>
        </div>
    </mat-card>
</div>
